export var getBaseUrl = function getBaseUrl(config, defaultBaseUrl) {
  return config.withAbsoluteLinks ? config.absoluteBaseUrl ? config.absoluteBaseUrl : defaultBaseUrl : "";
};
export var getLogoUrl = function getLogoUrl(config, baseUrl, defaultLogoUrl) {
  if (config.withAbsoluteLinks) {
    return "".concat(baseUrl).concat(defaultLogoUrl);
  }

  return defaultLogoUrl;
};